export default () => {
  const originalSetItem = window.localStorage.setItem

  window.localStorage.setItem = function (key, value) {
    if (key === 'refreshToken') {
      console.log(`refreshToken atualizado: ${value}`)
      console.trace('Stack trace para refreshToken')
    }
    if (key === 'token') {
      console.log(`token atualizado: ${value}`)
      console.trace('Stack trace para token')
    }
    originalSetItem.apply(this, arguments) // Mantém o comportamento original
  }
}